import { render, staticRenderFns } from "./ExternalTools-edeka.vue?vue&type=template&id=064fcf19&"
import script from "./ExternalTools-edeka.vue?vue&type=script&lang=js&"
export * from "./ExternalTools-edeka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports